import { render, staticRenderFns } from "./GetPremiumModal.vue?vue&type=template&id=9aa057a0&"
import script from "./GetPremiumModal.vue?vue&type=script&lang=js&"
export * from "./GetPremiumModal.vue?vue&type=script&lang=js&"
import style0 from "./GetPremiumModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports